<script lang="ts">
    import { _ } from "svelte-i18n"
    import { onMount } from "svelte"
    import { postPayment, reportFrontendError, errorCodeFrom } from "../../../api"
    import { cart, checkoutData, getAsyncCartSum } from "../../../functionTools/cart"
    import type { AuthorizationResponse, SessionResponse } from "../../../../../api/hooks/lib/klarna-api"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import CheckoutErrorBox from "./CheckoutErrorBox.svelte"

    interface Props {
        submitHandler: () => Promise<void>
    }

    let { submitHandler }: Props = $props()

    let kContainer: HTMLElement = $state()

    let initialized = $state(false)
    let errorCode: string | null = $state(null)
    async function initKlarna() {
        postPayment({
            type: "klarna",
            cart: $cart,
            sum: await getAsyncCartSum($cart),
            vat: $checkoutData.vat,
            contact: $checkoutData.contact,
            billingAddress: $checkoutData.billingAddress,
            deliveryAddress: $checkoutData.deliveryAddress,
        })
            .then((p) => {
                let payload = p.payload
                let session: SessionResponse = Array.isArray(payload) ? payload[0] : payload

                initialized = true
                kContainer.innerHTML = ""

                // @ts-ignore
                window.Klarna.Payments.init({
                    client_token: session.client_token,
                })

                // @ts-ignore
                window.Klarna.Payments.load(
                    {
                        container: "#klarna-payments-container",
                    },
                    (res: any) => {
                        console.log(res)
                    }
                )
            })
            .catch(async (e) => {
                console.log(e)
                errorCode =
                    errorCodeFrom(e) ||
                    (await reportFrontendError({
                        stage: "sdk-create",
                        provider: "klarna",
                        sdkError: JSON.stringify(e?.data || e).slice(0, 500),
                    }))
            })
    }
    let mounted = $state(false)
    onMount(() => {
        mounted = true
    })

    // @ts-ignore
    let klarnaScriptLoaded = !!window.Klarna

    // @ts-ignore
    window.klarnaAsyncCallback = initKlarna

    $effect(() => {
        if (klarnaScriptLoaded && mounted) initKlarna()
    })

    function authorize() {
        // @ts-ignore
        window.Klarna.Payments.authorize(null, null, (res: AuthorizationResponse) => {
            if (res.show_form && res.approved && res.authorization_token) {
                $checkoutData.payment.authorization_token = res.authorization_token
                submitHandler()
            }
        })
    }
</script>

<svelte:head>
    {#if !klarnaScriptLoaded}
        <script src="https://x.klarnacdn.net/kp/lib/v1/api.js" async></script>
    {/if}
</svelte:head>

<div id="k">
    <h4>{$_("klarna.order_now")}</h4>
    <CheckoutErrorBox code={errorCode} messageKey="checkout.error-payment" />
    {#if !initialized && !errorCode}<BarLoader />{/if}
    <div bind:this={kContainer} id="klarna-payments-container"></div>
    {#if initialized}
        <div style="text-align: right">
            <button type="button" class="button primary" onclick={authorize}>{$_("klarna.proceed")}</button>
        </div>
    {/if}
</div>

<style>
    #k {
        width: 600px;
        max-width: 100%;
    }
</style>
